import { PublicHeader } from "@/components/layout/PublicHeader"
import { ClassBrowser } from "@/features/public-classes"
import { Box } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/browse-classes")({
  component: BrowseClassesPage,
})

function BrowseClassesPage() {
  return (
    <Box minH="100vh" bg="gray.50">
      <PublicHeader />
      <ClassBrowser />
    </Box>
  )
}
